/* global axios */
import ApiClient from '../ApiClient';

class AiBotBadwordsAPI extends ApiClient {
  constructor(botId) {
    super(`agent_bots/${botId}/badwords`, { accountScoped: true });
  }

  bulk(params) {
    return axios.post(`${this.url}/bulk`, params);
  }
}

export default AiBotBadwordsAPI;
